import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ScrollingModule } from "@angular/cdk/scrolling";
import { CommonComponentsModule } from "src/app/common-components";
import { RouterModule } from "@angular/router";
import { PlanungApiTaskContactCreateComponent } from "./create/create.component";
import { PlanungApiTaskContactAvatarComponent } from "./avatar/avatar.component";
import { AnlageApiComponentsModule } from "src/app/anlage-api/components/anlage-components.module";

@NgModule({
  imports: [
    CommonModule,
    ScrollingModule,
    CommonComponentsModule,
    RouterModule,
    AnlageApiComponentsModule,
  ],
  declarations: [
    PlanungApiTaskContactAvatarComponent,
    PlanungApiTaskContactCreateComponent,
  ],
  exports: [
    PlanungApiTaskContactAvatarComponent,
    PlanungApiTaskContactCreateComponent,
  ],
})
export class PlanungApiTaskContactModule {}
